﻿<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title" id="my-modal-title">
      {{ "ADDRESS_VALIDATION" | globalTranslate }}
    </h1>
    <button
      type="button"
      class="btn-close"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  <div class="modal-body">
    <h2 class="page-header sr-only" role="heading" aria-level="1">
      {{ "ADDRESS_VALIDATION" | globalTranslate }}
    </h2>
    @if (saveExit) {
    <p>{{ "ADDRESS_VALIDATION_INFO" | globalTranslate }}</p>
    } @if (hasPhysicalAddress && isAppeal) {
    <div class="panel-section">
      <p>{{ "APPL_ADDRESS_VALIDATION_STATIC1" | globalTranslate }}</p>
      <div>
        @if (isAppealDemo) {
        <h2 class="section-header">
          {{ "APPL_ADDRESS_VALIDATION_STATIC2" | globalTranslate }}
        </h2>
        } @if (isAppealRep) {
        <h2 class="section-header">
          {{ "APPL_ADDRESS_VALIDATION_STATIC4" | globalTranslate }}
        </h2>
        }
        <hr />
      </div>
      <p>{{ "APPL_ADDRESS_VALIDATION_STATIC3" | globalTranslate }}</p>
      <form [formGroup]="form">
        <div class="row">
          <div class="col-md-9 mb-3">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                id="originalPhy"
                name="type"
                [attr.aria-label]="
                  'ADDRESS_VALIDATION_INFO_4' | globalTranslate
                "
                (change)="physicalSelect('originalPhy')"
                (keydown.enter)="$event.target['click']()"
                value="original"
                style="margin-left: -1.5rem"
              />
              <label class="form-check-label" for="originalPhy">
                <strong
                  >{{ "ADDRESS_VALIDATION_INFO_4" | globalTranslate }}:</strong
                >
              </label>
            </div>
            <div style="margin-left: 1.75rem">
              <span
                >{{ physicalAddress.originalAddress.addressLine1 }}<br
              /></span>
              @if (physicalAddress.originalAddress.addressLine2) {
              <span
                >{{ physicalAddress.originalAddress.addressLine2 }}<br
              /></span>
              }
              <span
                >{{ physicalAddress.originalAddress.city }},
                {{ physicalAddress.originalAddress.state.code }}
                {{
                  physicalAddress.originalAddress.zip | mask: "00000-9999"
                }}</span
              >
            </div>
          </div>
          @if (physicalAddress.suggestedAddress) {
          <div class="col-md-9 mb-3">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                id="suggestedPhy"
                name="type"
                [attr.aria-label]="
                  'ADDRESS_VALIDATION_INFO_6' | globalTranslate
                "
                (change)="physicalSelect('suggestedPhy')"
                (keydown.enter)="$event.target['click']()"
                value="suggested"
                style="margin-left: -1.5rem"
              />
              <label class="form-check-label" for="suggestedPhy">
                <strong
                  >{{ "ADDRESS_VALIDATION_INFO_6" | globalTranslate }}:</strong
                >
              </label>
            </div>
            <div style="margin-left: 1.75rem">
              <span
                >{{ physicalAddress.suggestedAddress.addressLine1 }}<br
              /></span>
              @if (physicalAddress.suggestedAddress.addressLine2) {
              <span
                >{{ physicalAddress.suggestedAddress.addressLine2 }}<br
              /></span>
              }
              <span
                >{{ physicalAddress.suggestedAddress.city }},
                {{ physicalAddress.suggestedAddress.state.code }}
                {{
                  physicalAddress.suggestedAddress.zip | mask: "00000-9999"
                }}</span
              >
            </div>
          </div>
          }
          <div class="col-12 mt-3">
            <nh-alert type="warning" [isOpen]="physicalAddressAlert">
              <div class="d-flex align-items-start">
                <div class="me-2 flex-shrink-0">
                  <img
                    src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="flex-grow-1">
                  <span>{{ "ENTER_MANDATORY" | globalTranslate }}</span>
                </div>
              </div>
            </nh-alert>
          </div>
        </div>
      </form>
    </div>
    } @if ((hasPhysicalAddress || hasNursingAddress) && !isAppeal) {
    <div class="panel-section">
      @if (hasPhysicalAddress) {
      <div>
        <h2 class="section-header">
          {{
            (isRidpFlow
              ? "ADDRESS_VALIDATION"
              : isMedicalAppealDemo
              ? "MEDICAL_APPEAL_ADDRESS_HEADER"
              : "HOUSEHOLD_PHYSICAL_ADDRESS"
            ) | globalTranslate
          }}
        </h2>
        <hr />
      </div>
      } @if (hasNursingAddress) {
      <div>
        <h2 class="section-header">
          {{ "NURSING_FACILITY_ADDRESS" | globalTranslate }}
        </h2>
        <hr />
      </div>
      } @if (physicalAddress.suggestedAddress) {
      <div>
        @if (!isRidpFlow) {
        <p>{{ "ADDRESS_VALIDATION_INFO_1" | globalTranslate }}</p>
        } @if (isRidpFlow) {
        <p>{{ "ADDRESS_VALIDATION_RIDP" | globalTranslate }}</p>
        }
      </div>
      } @if (!physicalAddress.suggestedAddress) {
      <div>
        <p>
          {{
            (isRidpFlow
              ? "ADDRESS_VALIDATION_INFO_RIDP"
              : "ADDRESS_VALIDATION_INFO_2"
            ) | globalTranslate
          }}
        </p>
        @if (isRidpFlow) {
        <p [innerHTML]="'ADDRESS_VALIDATION_INFO_3_RIDP' | globalTranslate"></p>
        } @if (!isRidpFlow) {
        <p [innerHTML]="'ADDRESS_VALIDATION_INFO_3' | globalTranslate"></p>
        }
      </div>
      }
      <form [formGroup]="form">
        <div class="row">
          <div class="col-md-9 mb-3">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                id="originalPhy"
                name="type"
                [attr.aria-label]="
                  'ADDRESS_VALIDATION_INFO_4' | globalTranslate
                "
                (change)="physicalSelect('originalPhy')"
                (keydown.enter)="$event.target['click']()"
                value="original"
                style="margin-left: -1.5rem"
              />
              <label class="form-check-label" for="originalPhy">
                @if (physicalAddress.suggestedAddress) {
                <strong>
                  {{ "ADDRESS_VALIDATION_INFO_4" | globalTranslate }}:
                </strong>
                } @if (!physicalAddress.suggestedAddress) {
                <strong>
                  {{ "ADDRESS_VALIDATION_INFO_5" | globalTranslate }}:
                </strong>
                }
              </label>
            </div>
            <div style="margin-left: 1.75rem">
              <span
                >{{ physicalAddress.originalAddress.addressLine1 }}<br
              /></span>
              @if (physicalAddress.originalAddress.addressLine2) {
              <span
                >{{ physicalAddress.originalAddress.addressLine2 }}<br
              /></span>
              }
              <span
                >{{ physicalAddress.originalAddress.city }},
                {{ physicalAddress.originalAddress.state.code }}
                {{
                  physicalAddress.originalAddress.zip | mask: "00000-9999"
                }}</span
              >
            </div>
          </div>
          @if (physicalAddress.suggestedAddress) {
          <div class="col-md-9 mb-3">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                id="suggestedPhy"
                name="type"
                [attr.aria-label]="
                  'ADDRESS_VALIDATION_INFO_6' | globalTranslate
                "
                (change)="physicalSelect('suggestedPhy')"
                (keydown.enter)="$event.target['click']()"
                value="suggested"
                style="margin-left: -1.5rem"
              />
              <label class="form-check-label" for="suggestedPhy">
                <strong
                  >{{ "ADDRESS_VALIDATION_INFO_6" | globalTranslate }}:</strong
                >
              </label>
            </div>
            <div style="margin-left: 1.75rem">
              <span
                >{{ physicalAddress.suggestedAddress.addressLine1 }}<br
              /></span>
              @if (physicalAddress.suggestedAddress.addressLine2) {
              <span
                >{{ physicalAddress.suggestedAddress.addressLine2 }}<br
              /></span>
              }
              <span
                >{{ physicalAddress.suggestedAddress.city }},
                {{ physicalAddress.suggestedAddress.state.code }}
                {{
                  physicalAddress.suggestedAddress.zip | mask: "00000-9999"
                }}</span
              >
            </div>
          </div>
          }
          <div class="col-12 mt-3">
            <nh-alert type="warning" [isOpen]="physicalAddressAlert">
              <div class="d-flex align-items-start">
                <div class="me-2 flex-shrink-0">
                  <img
                    src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="flex-grow-1">
                  <span>{{ "ENTER_MANDATORY" | globalTranslate }}</span>
                </div>
              </div>
            </nh-alert>
          </div>
        </div>
      </form>
    </div>
    } @if (hasMalingAddress || hasDischargeAddress) {
    <div class="panel-section">
      @if (hasMalingAddress) {
      <div>
        <h2 class="section-header">
          {{ "HOUSEHOLD_MAILING_ADDRESS" | globalTranslate }}
        </h2>
        <hr />
      </div>
      } @if (hasDischargeAddress) {
      <div>
        <h2 class="section-header">
          {{ "NURSING_FACILITY_ADDRESS" | globalTranslate }}
        </h2>
        <hr />
      </div>
      } @if (!mailingAddress.suggestedAddress) {
      <div>
        <p>{{ "ADDRESS_VALIDATION_INFO_2" | globalTranslate }}</p>
        <p [innerHTML]="'ADDRESS_VALIDATION_INFO_3' | globalTranslate"></p>
      </div>
      }
      <form [formGroup]="form">
        <div class="row">
          <div class="col-md-9 mb-3">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                id="originalMail"
                name="type"
                [attr.aria-label]="
                  'ADDRESS_VALIDATION_INFO_4' | globalTranslate
                "
                (change)="mailingSelect('originalMail')"
                (keydown.enter)="$event.target['click']()"
                value="original"
                style="margin-left: -1.5rem"
              />
              <label class="form-check-label" for="originalMail">
                @if (mailingAddress.suggestedAddress) {
                <strong>
                  {{ "ADDRESS_VALIDATION_INFO_4" | globalTranslate }}:
                </strong>
                } @if (!mailingAddress.suggestedAddress) {
                <strong>
                  {{ "ADDRESS_VALIDATION_INFO_5" | globalTranslate }}:
                </strong>
                }
              </label>
            </div>
            <div style="margin-left: 1.75rem">
              <span
                >{{ mailingAddress.originalAddress.addressLine1 }}<br
              /></span>
              @if (mailingAddress.originalAddress.addressLine2) {
              <span
                >{{ mailingAddress.originalAddress.addressLine2 }}<br
              /></span>
              }
              <span
                >{{ mailingAddress.originalAddress.city }},
                {{ mailingAddress.originalAddress.state.code }}
                {{
                  mailingAddress.originalAddress.zip | mask: "00000-9999"
                }}</span
              >
            </div>
          </div>
          @if (mailingAddress.suggestedAddress) {
          <div class="col-md-9 mb-3">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                id="suggestedMail"
                name="type"
                [attr.aria-label]="
                  'ADDRESS_VALIDATION_INFO_6' | globalTranslate
                "
                (change)="mailingSelect('suggestedMail')"
                (keydown.enter)="$event.target['click']()"
                value="suggested"
                style="margin-left: -1.5rem"
              />
              <label class="form-check-label" for="suggestedMail">
                <strong
                  >{{ "ADDRESS_VALIDATION_INFO_6" | globalTranslate }}:</strong
                >
              </label>
            </div>
            <div style="margin-left: 1.75rem">
              <span
                >{{ mailingAddress.suggestedAddress.addressLine1 }}<br
              /></span>
              @if (mailingAddress.suggestedAddress.addressLine2) {
              <span
                >{{ mailingAddress.suggestedAddress.addressLine2 }}<br
              /></span>
              }
              <span
                >{{ mailingAddress.suggestedAddress.city }},
                {{ mailingAddress.suggestedAddress.state.code }}
                {{
                  mailingAddress.suggestedAddress.zip | mask: "00000-9999"
                }}</span
              >
            </div>
          </div>
          }
          <div class="col-12 mt-3">
            <nh-alert type="warning" [isOpen]="mailingAddressAlert">
              <div class="d-flex align-items-start">
                <div class="me-2 flex-shrink-0">
                  <img
                    src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="flex-grow-1">
                  <span>{{ "ENTER_MANDATORY" | globalTranslate }}</span>
                </div>
              </div>
            </nh-alert>
          </div>
        </div>
      </form>
    </div>
    } @if (hasAssistingAddress) {
    <div class="panel-section">
      <h2 class="section-header">
        {{ "ASSISTING_PERSON_ADDRESS" | globalTranslate }}
      </h2>
      <hr />
      @if (!assistingAddress.suggestedAddress) {
      <div>
        <p>{{ "ADDRESS_VALIDATION_INFO_2" | globalTranslate }}</p>
        <p [innerHTML]="'ADDRESS_VALIDATION_INFO_3' | globalTranslate"></p>
      </div>
      }
      <form [formGroup]="form">
        <div class="row">
          <div class="col-md-9 mb-3">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                id="originalAssis"
                name="type"
                [attr.aria-label]="
                  'ADDRESS_VALIDATION_INFO_4' | globalTranslate
                "
                (change)="assistingSelect('originalAssis')"
                (keydown.enter)="$event.target['click']()"
                value="original"
                style="margin-left: -1.5rem"
              />
              <label class="form-check-label" for="originalAssis">
                @if (assistingAddress.suggestedAddress) {
                <strong>
                  {{ "ADDRESS_VALIDATION_INFO_4" | globalTranslate }}:
                </strong>
                } @if (!assistingAddress.suggestedAddress) {
                <strong>
                  {{ "ADDRESS_VALIDATION_INFO_5" | globalTranslate }}:
                </strong>
                }
              </label>
            </div>
            <div style="margin-left: 1.75rem">
              <span
                >{{ assistingAddress.originalAddress.addressLine1 }}<br
              /></span>
              @if (assistingAddress.originalAddress.addressLine2) {
              <span
                >{{ assistingAddress.originalAddress.addressLine2 }}<br
              /></span>
              }
              <span
                >{{ assistingAddress.originalAddress.city }},
                {{ assistingAddress.originalAddress.state.code }}
                {{
                  assistingAddress.originalAddress.zip | mask: "00000-9999"
                }}</span
              >
            </div>
          </div>
          @if (assistingAddress.suggestedAddress) {
          <div class="col-md-9 mb-3">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                id="suggestedAssis"
                name="type"
                [attr.aria-label]="
                  'ADDRESS_VALIDATION_INFO_6' | globalTranslate
                "
                (change)="assistingSelect('suggestedAssis')"
                (keydown.enter)="$event.target['click']()"
                value="suggested"
                style="margin-left: -1.5rem"
              />
              <label class="form-check-label" for="suggestedAssis">
                <strong
                  >{{ "ADDRESS_VALIDATION_INFO_6" | globalTranslate }}:</strong
                >
              </label>
            </div>
            <div style="margin-left: 1.75rem">
              <span
                >{{ assistingAddress.suggestedAddress.addressLine1 }}<br
              /></span>
              @if (assistingAddress.suggestedAddress.addressLine2) {
              <span
                >{{ assistingAddress.suggestedAddress.addressLine2 }}<br
              /></span>
              }
              <span
                >{{ assistingAddress.suggestedAddress.city }},
                {{ assistingAddress.suggestedAddress.state.code }}
                {{
                  assistingAddress.suggestedAddress.zip | mask: "00000-9999"
                }}</span
              >
            </div>
          </div>
          }
          <div class="col-12 mt-3">
            <nh-alert type="warning" [isOpen]="AssistingAddressAlert">
              <div class="d-flex align-items-start">
                <div class="me-2 flex-shrink-0">
                  <img
                    src="../../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="flex-grow-1">
                  <span>{{ "ENTER_MANDATORY" | globalTranslate }}</span>
                </div>
              </div>
            </nh-alert>
          </div>
        </div>
      </form>
    </div>
    }
  </div>
  <div class="modal-footer d-block">
    <div class="row justify-content-start form-actions">
      <div class="col-md-3">
        <button
          id="dialog"
          type="button"
          class="btn form-actions-btn btn-block btn-secondary"
          [disabled]="!isPhyValid || !isMailValid || !isAssisValid"
          (click)="onConfirm()"
        >
          {{ (isRidpFlow ? "CONTINUE_1" : "ADDRESS_SUBMIT") | globalTranslate }}
        </button>
      </div>
      <div class="col-md-3">
        <button
          id="dialog"
          type="button"
          class="btn form-actions-btn btn-block btn-link"
          (click)="onCancel()"
        >
          {{ "CANCEL" | globalTranslate }}
        </button>
      </div>
    </div>
  </div>
</div>